import { render } from "./OrderItem.vue?vue&type=template&id=6a85ef8e&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=ts"
export * from "./OrderItem.vue?vue&type=script&lang=ts"

import "./OrderItem.vue?vue&type=style&index=0&id=6a85ef8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a85ef8e"

export default script